import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';
import moment from 'moment';
import { path } from 'ramda';
import * as yup from 'yup';

import DatePicker from 'components/common/form/DatePicker';
import TimePicker from 'components/common/form/TimePicker';
import SwitchComponent from 'components/common/form/Switch';
import Input from 'components/common/form/Input';
import { DATE_FORMATS } from 'constants/dateFormats';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import ItemModalFooter from 'components/common/ItemModalFooter';
import AllDayField from 'components/common/controls/AllDayField';
import withFormWrapper from 'components/hocs/withFormWrapper';
import { required } from 'utils/validators';

const validationSchema = yup.object().shape({
    date: yup.string().required(),
    description: yup.string().maxLength(127).required()
});

const moreThenTimeFrom = (time, model) => {
    const timeFrom = path(['time', 'from'], model);
    return moment(time, DATE_FORMATS.timeFormat).isBefore(moment(timeFrom, DATE_FORMATS.timeFormat)) && 'lessThanStartTime';
};

@withAutoFocusForm
@withFormWrapper({
    mapPropsToValues: props => props.initialValues,
    validationSchema
})
export default class SotrMeetModal extends Component {
    static propTypes = {
        modal: PropTypes.object.isRequired,
        titleTranslate: PropTypes.string.isRequired,
        formAction: PropTypes.object,
        allday: PropTypes.any,
        handleSubmit: PropTypes.func.isRequired,
        form: PropTypes.object.isRequired
    }

    state = {
        allday: !!this.props.allday
    }

    renderFooter() {
        const { formAction: { meta }, handleSubmit } = this.props;

        return (
            <ItemModalFooter meta={meta} handleSubmit={handleSubmit} />
        );
    }

    onChangeSwitch = (allday) => {
        if (allday) {
            this.props.form.change('time.to', '');
            this.props.form.change('time.from', '');
        }

        this.setState({ allday });
    }

    validateFrom = value => !this.state.allday ? required(value) : undefined;
    validateTo = (value, all) => !this.state.allday ? required(value, all) || moreThenTimeFrom(value, all) : undefined;

    render() {
        const { modal, titleTranslate } = this.props;
        const { allday } = this.state;

        return (
            <Modal {...modal} title={<Translate content={titleTranslate} />} footer={this.renderFooter()}>
                <Field
                    name='description'
                    component={Input}
                    label={{ content: 'calendar.create.event' }}
                />
                <Field
                    name='date'
                    component={DatePicker}
                    label={{ content: 'calendar.date' }}
                />
                <AllDayField
                    checked={allday}
                    onChange={this.onChangeSwitch}
                />
                <Field  name='time.from'
                        component={TimePicker}
                        validate={this.validateFrom}
                        hidden={allday}
                        label={{ content: 'calendar.create.startTime', required: true }} />
                <Field  name='time.to'
                        component={TimePicker}
                        validate={this.validateTo}
                        hidden={allday}
                        label={{ content: 'calendar.create.endTime', required: true }} />
                <Field
                    name="showInPlanner"
                    component={SwitchComponent}
                    label={{ content: 'calendar.show_in_planner' }}
                />
                <Field
                    name="ownEvent"
                    component={SwitchComponent}
                    label={{ content: 'calendar.own_event' }}
                />
            </Modal>
        );
    }
}
